var _style, _defs, _defs2, _path, _defs3, _path2, _defs4, _path3, _defs5, _path4, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.4 19",
    style: {
      enableBackground: "new 0 0 64.4 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{clip-path:url(#SVGID_6_);fill:#B98737;}\n\t.st3{clip-path:url(#SVGID_8_);fill:#B98737;}\n\t.st4{clip-path:url(#SVGID_10_);fill:#B98737;}\n\t.st5{fill:#B98737;}\n\t.st6{font-family:'SabonLTPro-Bold';}\n\t.st7{font-size:5.4906px;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -1.6,
    y: -1.7,
    width: 28.4,
    height: 28.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -1.6,
    y: -1.7,
    width: 28.4,
    height: 28.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.1,1.8c0-0.2-1-0.5-1-0.5s-0.2-1.3-1.6-1.3c-2.4,0-2.6,4.4-2.6,4.4c-0.7,0.6-1.2,1.3-1.2,1.3 c-0.1-3.3-2.4-5.1-5.5-5.1c-4.3,0-7.5,2.4-13.1,1.4c0,0,2,6.3,9.1,8.6c0.5-1.4,1.3-2.8,2.9-3.6c1.6-0.8,3.3-0.3,3.3,0.9 c0,1.8-2.6,5.1-9,7.1c-0.3,0.1-0.6,0.2-0.8,0.3c1.1,1.8,2.8,3.4,5.5,3.6c-0.1-1.8,1.7-4.6,3.5-5.1c6.2-0.3,10.3-3.4,10.3-7.1 c0-1.9-1-2.7-1-3.8C23.9,1.8,25.1,2,25.1,1.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -1.6,
    y: -1.7,
    width: 28.4,
    height: 28.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17.6,7c3.1-5.1,7.2-4.8,7.2-4.6s-3.5-0.9-7,4.7"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: -1.6,
    y: -1.7,
    width: 28.4,
    height: 28.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.9,13.5c1.3-2.3,2.4-4,3.6-4c1.1,0-0.6,2.8-4,2.8c-1.9,0-3.3-1.4-3.3-3.4c0-2.3,2.1-5.9,5.3-5.9 c2.5,0,3.8,1.4,3.8,2.6c0,1.4-2.3,1.8-2.3,0.2c-0.7,0.4-0.8,1.8,0.8,1.8c1.1,0,1.6-1.2,1.6-2c0-1.3-1.3-2.8-3.9-2.8 c-3.6,0-6.5,3.1-6.5,6c0,2.4,1.5,3.6,4.4,3.6c4.3,0,6.4-3.8,4.5-3.8c-1.6,0-2.6,1.9-4.4,4.8c-0.7,1.1-2.4,3.8-5,3.8 c-3,0-1.1-3.7,4.1-3.7l0.2-0.2c-7.9,0-7.5,4.1-4.3,4.1C12.3,17.5,14.1,14.9,14.9,13.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: -1.6,
    y: -1.7,
    width: 28.4,
    height: 28.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.9,7.1l-3.9,6.4c-0.7,1.1-1.7,2-2.8,2c-2.1,0-0.7-2.1,2.8-2.1c5.2,0,8.8-3.4,8.8-6.6 c0-3.2-2.7-5.3-6.3-5.3c-4.3,0-7.5,2.6-7.7,4.9C8.4,9.1,13,9.2,13,9.2c-3.4,0-5.4-0.7-5.3-2.8c0.2-2.1,3.8-5.1,8.7-5.1 c4.6,0,7.9,2.1,7.9,5.5c0,3.3-4.6,6.8-10.6,6.8l0,0c-2.6,0-3.2,1.7-2.4,1.7c0.3,0,1.3-0.1,2.4-1.8l4-6.5"
  }))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 26.6156 7.3374)",
    className: "st5 st6 st7"
  }, " CAVE ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 26.6156 13.9274)",
    className: "st5 st6 st7"
  }, "LA COLOMBE"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.34a064a460951c0351c466f2c1375c60.svg";
export { ForwardRef as ReactComponent };